<atn-ds-page>
  <atn-ds-page-header
    pageHeader
    [name]="appNameSg()"
    [breadcrumbs]="breadcrumbsSg()"
  />
  <atn-ds-floating-horizontal-tabs>
    <ng-template
      atnDsTab
      name="General"
    >
      <atn-admin-app-page-general-tab />
    </ng-template>

    <ng-template
      atnDsTab
      name="Pages"
    >
      <atn-admin-app-page-app-pages-tab />
    </ng-template>

    @if (supportsScenariosSg()) {
      <ng-template
        atnDsTab
        name="Scenarios"
      >
        <atn-admin-app-page-scenarios-tab />
      </ng-template>
    }

    @if (canManageUsersSg()) {
      <ng-template
        atnDsTab
        name="Users"
      >
        <atn-admin-app-page-users-tab />
      </ng-template>
    }

    @if (canManageUsersSg()) {
      <ng-template
        atnDsTab
        name="Agents"
      >
        <atn-admin-app-page-agents-tab />
      </ng-template>
    }
  </atn-ds-floating-horizontal-tabs>
</atn-ds-page>
